export default "__VITE_ASSET__BWPnQo8J__"